import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { SearchWithinComponent } from './search-within/search-within.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SelectableSearchResultComponent } from './selectable-search-result/selectable-search-result.component';
import { SearchDeliveryToggleFilterComponent } from './search-toggle-filter/search-delivery-toggle-filter.component';
import { SearchSkeletonComponent } from './search-skeleton/search-skeleton.component';
import { SearchOperationsComponent } from './search-operations/search-operations.component';

@NgModule({
  declarations: [
    SearchWithinComponent,
    SelectableSearchResultComponent,
    SearchDeliveryToggleFilterComponent,
    SearchSkeletonComponent,
    SearchOperationsComponent,
  ],
  imports: [CommonModule, SharedModule, FormsModule, IonicModule],
  exports: [
    SearchWithinComponent,
    SelectableSearchResultComponent,
    SearchDeliveryToggleFilterComponent,
    SearchSkeletonComponent,
    SearchOperationsComponent,
  ],
})
export class SearchSharedModule {}
